import { render } from "./FooterBase.vue?vue&type=template&id=7377b5be&scoped=true"
import script from "./FooterBase.vue?vue&type=script&lang=js"
export * from "./FooterBase.vue?vue&type=script&lang=js"

import "./FooterBase.vue?vue&type=style&index=0&id=7377b5be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7377b5be"]])

export default __exports__